module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footerbar"
    }
  }, [_c('footer', {
    staticClass: "bg-dark type-2"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "footer-block"
  }, [_c('div', {
    staticClass: "f_text color-grey-7"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt\n                                    ut labore magna aliqua. Ut aliquip ex ea commodo consequat.")]), _vm._v(" "), _c('div', {
    staticClass: "footer-share"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "fa fa-instagram"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "fa fa-google-plus"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "fa fa-pinterest"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-sm-6 no-padding"
  }, [_c('div', {
    staticClass: "footer-block"
  }, [_c('h6', [_vm._v("Otro")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "footer-block"
  }, [_c('h6', [_vm._v("Espacio para logos:")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "footer-block"
  }, [_c('h6', [_vm._v("Contact Info")]), _vm._v(" "), _c('div', {
    staticClass: "contact-info"
  }, [_c('div', {
    staticClass: "contact-line color-grey-3"
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" "), _c('span', [_vm._v("Taganga, Santa Marta")])]), _vm._v(" "), _c('div', {
    staticClass: "contact-line color-grey-3"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:57 (5) 4 219057"
    }
  }, [_vm._v("57 (5) 4 219057")])]), _vm._v(" "), _c('div', {
    staticClass: "contact-line color-grey-3"
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "intent://send/+573167561312#Intent;scheme=smsto;package=com.whatsapp;action=android.intent.action.SENDTO;end"
    }
  }, [_vm._v("+57 316 756 13 12")])]), _vm._v(" "), _c('div', {
    staticClass: "contact-line color-grey-3"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto://peli.k@hotmail.com"
    }
  }, [_vm._v("\n                                            peli.k@hotmail.com\n                                        ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-link bg-black"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_c('span', [_vm._v("© 2017 Hostal Pelikan Taganga")])]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "link-aqua",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Privacy Policy ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "link-aqua",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sitemap")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d059bcbe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footerbar.vue
// module id = 19
// module chunks = 0